import React from 'react';
import PropTypes from 'prop-types';
import TableCell from '../../modules/DataTable/components/TableCell';

/**
 * Table row which can be expanded with custom content
 *
 * @param {{}} props
 * @constructor
 */
function ExpandableRow(props) {
    function handleClick(event) {
        if (props.onRowExpand
            && props.index !== null
            && !event.target.closest('.sales__catalogueRefineLotsEntriesWrp')) {
            props.onRowExpand(props.index);
        }
    }

    return (
        <tr
            className={`ui-table__row ${props.evenClass}`}
            onClick={handleClick}
        >
            {props.columns.map((colData) => {
                if (colData.customCell) {
                    const CustomCell = colData.customCell.component
                        ? colData.customCell.component
                        : colData.customCell;

                    return (
                        <TableCell key={colData.columnName} {...colData}>
                            <CustomCell
                                index={props.index}
                                rowData={props.children}
                                {...colData}
                                onSelect={props.onRowSelect}
                                isSelected={props.isSelected}
                                isExpanded={props.isActive}
                            />
                        </TableCell>
                    );
                }

                return (
                    <TableCell key={colData.columnName} {...colData}>
                        {props.children[colData.columnName]}
                    </TableCell>
                );
            })}
        </tr>
    );
}

ExpandableRow.propTypes = {
    /**
     * Row data
     */
    children: PropTypes.object,
    /**
     * List of table columns
     */
    columns: PropTypes.array,
    /**
     * Key of current row
     */
    index: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
        PropTypes.object,
    ]),
    /**
     * On row click event handler
     */
    onRowExpand: PropTypes.func,
    /**
     * Row class, should be 'odd' or 'even'
     */
    evenClass: PropTypes.oneOf(['odd', 'even']),
    /**
     * On row select event handler
     */
    onRowSelect: PropTypes.func,
    /**
     * TRUE if current row is expanded, FALSE otherwise
     */
    isActive: PropTypes.bool,
    /**
     * Is row selected
     */
    isSelected: PropTypes.bool
};

export default ExpandableRow;



// WEBPACK FOOTER //
// ./src/js/components/DataTable/ExpandableRow.js